/**
 * One line of plain text from a markdown message, for a preview that CSS truncates: the agent
 * list, a toast, the reply-to quote, a turn summary. Agents write markdown, and a preview cut
 * from the raw body showed `**`, backticks and list dashes. The markers are removed here, whole,
 * before anything is cut, so an ellipsis can never leave half a token behind.
 */
export function previewText(markdown: string): string {
  let text = markdown.replace(/\r\n?/g, "\n");
  // Code blocks become a placeholder; an unclosed fence runs to the end.
  text = text.replace(/(^|\n)[ \t]*(```|~~~)[^\n]*\n[\s\S]*?(?:\n[ \t]*\2[^\n]*(?=\n|$)|$)/g, "$1code\n");
  text = text.replace(/!\[[^\]]*\]\([^)]*\)/g, "📷 Image");
  text = text.replace(/\[([^\]]+)\]\([^)]*\)/g, "$1");
  text = text.replace(/<((?:https?|mailto):[^>\s]+)>/g, "$1");

  const lines = text.split("\n").map((raw) => {
    let line = raw.trim();
    if (/^([-*_])(\s*\1){2,}$/.test(line)) return ""; // horizontal rule
    if (/^\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?$/.test(line)) return ""; // table separator
    line = line.replace(/^(>\s?)+/, "");
    line = line.replace(/^#{1,6}\s+/, "");
    line = line.replace(/^([-*+]|\d+[.)])\s+/, "");
    line = line.replace(/^\[[ xX]\]\s+/, "");
    if (line.startsWith("|")) line = line.replace(/^\|\s*|\s*\|$/g, "").replace(/\s*\|\s*/g, " · ");
    return line;
  });
  text = lines.filter(Boolean).join(" ");

  text = text.replace(/`+([^`]+?)`+/g, "$1");
  text = text.replace(/(\*\*|__)(?=\S)([\s\S]*?\S)\1/g, "$2");
  text = text.replace(/~~(?=\S)([\s\S]*?\S)~~/g, "$1");
  text = text.replace(/(^|[^\w*])\*(?=\S)([^*]*?\S)\*(?![\w*])/g, "$1$2");
  text = text.replace(/(^|[^\w])_(?=\S)([^_]*?\S)_(?!\w)/g, "$1$2");
  // Whatever pairing left over (a marker whose partner was never written) is still noise.
  text = text.replace(/\*\*|`/g, "");
  return text.replace(/\s+/g, " ").trim();
}
